import { IDividerProps } from './types'
import styles from './styles.module.scss'
import clsx from 'clsx'

export const Divider = ({ margin = 'md', variant = 'solid', ...props }: IDividerProps) => {
  return (
    <div
      className={clsx(styles.divider, styles[variant], styles[margin], props.className)}
      data-testid="mui-divider"
      {...props}
    ></div>
  )
}
